import React from 'react';
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {FooterContainerBox} from "./boxes/footer-container.box";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {RegulationGameSessionIdComponent} from "../../../../../common/parts/regulation-game-session-id/regulation-game-session-id.component"
import {RegulationParticipationTicketIdComponent} from "../../../../../common/parts/regulation-participation-ticket-id/regulation-participation-ticket-id.component"
import {BlankHorizontalSeparatorBox} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {PipeHorizontalSeparatorBox} from "../../../../../../../basic-components/pipe-separator/pipe-horizontal-separator.box";
import {Check} from "@sparkware/app-utils";
import {GameFooterBarComponent} from "../../../../game-footer-bar.component";
import {JackpotBarMagicBallComponent} from '../../../../../jackpot-bar-magic-ball/jackpot-bar-magic-ball.component';

export const ItalyGamePlayPcFooterBarComponent = observer(
    class ItalyGamePlayPcFooterBarComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {

        private shouldRenderIGCMagic8Ball = () => {
            // If jackpot bet is enabled then the magic ball button will be rendered in game-jackpot-bar.component
            if (this.services.jackpotBet.isEnabled && this.props.gameContext.gameInfo.hasJackpotBet) {
                return false;
            }
            return this.services.magic8ball.shouldRenderBall;
        };

        private _renderBottomSection = () => {
            if (!this.shouldRenderIGCMagic8Ball()) {
                return null;
            }
            return <FooterContainerBox alignItems='center' justifyContent='center'>
                <div style={{padding: "0.5rem"}}>
                    <JackpotBarMagicBallComponent />
                </div>
            </FooterContainerBox>
        }

        private _renderTopSection = () => {
            if (
                Check.isNullOrUndefined(this.props.gameContext.gameSessionData.regulationGameSessionId)
                && Check.isNullOrUndefined(this.props.gameContext.gameSessionData.regulationParticipationTicketId)
            ) {
                return null;
            }
            return (
                <FooterContainerBox alignItems='center' justifyContent='flex-start'>
                    <BlankHorizontalSeparatorBox/>
                    <RegulationGameSessionIdComponent gameContext={this.props.gameContext}/>
                    <PipeHorizontalSeparatorBox/>
                    <RegulationParticipationTicketIdComponent gameContext={this.props.gameContext}/>
                </FooterContainerBox>
            );
        }

        render() {
            if (
                Check.isNullOrUndefined(this.props.gameContext.gameSessionData.regulationGameSessionId)
                && Check.isNullOrUndefined(this.props.gameContext.gameSessionData.regulationParticipationTicketId)
                && !this.shouldRenderIGCMagic8Ball()
            ) {
                return null;
            }

            return (
                <GameFooterBarComponent gameContext={this.props.gameContext} renderTopSection={this._renderTopSection} renderBottomSection={this._renderBottomSection}/>
            )
        }
    }
);